<pt-breadcrumbs class="bg-white" [breadcrumbs]="breadcrumbs()" />
<div class="border-b border-solid border-slate-300"></div>

@if (practice(); as practice) {
  @if (isEnabled()) {
    <pr-ai-receptionist-knowledge-base-editor [practice]="practice" />
  } @else {
    <pr-ai-receptionist-landing [practice]="practice" />
  }
}
